const hexToRgb = (hex) => {
  if (hex.charAt && hex.charAt(0) === "#") {
    hex = removeHash(hex)
  }

  if (hex.length === 3) {
    hex = expand(hex)
  }

  var bigint = parseInt(hex, 16)
  var r = (bigint >> 16) & 255
  var g = (bigint >> 8) & 255
  var b = bigint & 255

  return [r, g, b]
}

const removeHash = (hex) => {
  var arr = hex.split("")
  arr.shift()
  return arr.join("")
}

const expand = (hex) => {
  return hex
    .split("")
    .reduce(function (accum, value) {
      return accum.concat([value, value])
    }, [])
    .join("")
}

const contrast = (hex) => {
  var rgb = hexToRgb(hex)
  var o = Math.round(
    (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) /
      1000
  )

  return o <= 180 ? "dark" : "light"
}

export { hexToRgb, removeHash, expand, contrast }
